module.exports = __webpack_public_path__ + "img/DW365-180.6691bd83.jpg";